import React from "react";


import { Link } from "./styles/Design";
import { withNamespaces } from "react-i18next";
import i18next from "i18next";
import ARLogo from "../assets/images/logo/logoAR_Dark.svg";
import ENLogo from "../assets/images/logo/logoEN_Dark.svg";

import styled from "styled-components";
import { paymentMethods, socialIcons } from "../assets";
import { theme } from "../style";

const translations = [
  "Legal Translation",
  "Technical Translation",
  "Marketing Translation",
  "Financial Translation",
  "Website Translation",
  "Document translation",
];
const services = ["Brows Job", "brows service", "Add job", "Add service"];

const Logo = styled.img`
  max-width: 110px;
  height: auto;
`;

const FooterContainer = styled.footer`
  width: 100%;
  height: auto;
  background-color: ${({ theme }) => theme.colors.footerBackgroundColor};
  display: flex;
  justify-content: space-between;
  padding: 70px 135px;
  @media (max-width: 768px) {
    padding: 0 1rem;
    flex-direction: column;
  }
`;

const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1rem;
  ${({ flex }) => flex && `flex: ${flex};`}
  @media (max-width: 768px) {
    align-items: center;
    margin-bottom: 1rem;
  }
`;

const FooterDescription = styled.p`
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.gray};
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    text-align: center;
    margin: 2rem 0;
  }
`;
const SocialIconsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 90%;

  margin-top: 1rem;
  @media (max-width: 768px) {
    margin: 0 auto;
  }
`;
const ListTitle = styled.h3`
  color: ${({ theme }) => theme.colors.secondary};
  font-size: ${({ theme }) => theme.font.med};
  font-weight: 600;
  margin-bottom: 1rem;
`;
const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  height: 90%;
`;
const ListItem = styled.li`
  margin: 1rem 0;
  font-size: ${({ theme }) => theme.font.XXsmall};
  font-weight: 300;
  color: ${({ theme }) => theme.colors.gray};

  &:hover {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.lightGray};
  }
  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const Footer = ({ t }) => {
  const { language } = i18next;

  return (
    <>
      <FooterContainer>
        <FooterColumn flex={1.5}>
          {language === "en-US" || language === "en" ? (
            <Logo src={ENLogo} alt="English logo" />
          ) : (
            <Logo src={ARLogo} alt="Arabic logo" />
          )}
          <FooterDescription>
            The first Arab and international platform that cares about
            translators around the world and is the first professional platform
            at the level of remote translation
          </FooterDescription>
          <SocialIconsContainer>
            {socialIcons.map(({ url, icon, name }) => (
              <a href={url} target="_blank" rel="noreferrer">
                <img src={icon} alt={name}></img>
              </a>
            ))}
          </SocialIconsContainer>
        </FooterColumn>
        <FooterColumn flex={1}>
          <ListTitle>Translations</ListTitle>
          <List>
            {translations.map((e, i) => (
              <ListItem key={i}>
                <Link color={theme.colors.gray} to={`/${e}`}>
                  {e}
                </Link>
              </ListItem>
            ))}
          </List>
        </FooterColumn>
        <FooterColumn flex={1}>
          <ListTitle>services</ListTitle>
          <List>
            {services.map((e, i) => (
              <ListItem key={i}>
                <Link color={theme.colors.gray} to={`/${e}`}>
                  {e}
                </Link>
              </ListItem>
            ))}
          </List>
        </FooterColumn>
        <FooterColumn flex={1}>
          <ListTitle>Contact</ListTitle>
          <a
            style={{
              textDecoration: "none",
              color: theme.colors.gray,
            }}
            href="tel:0567306009"
          >
            0567306009
          </a>
          <p
            style={{
              color: theme.colors.gray,
              margin: "1rem 0",
            }}
          >
            Email:
            <a
              href={`mailto: torarjim@gamail.com`}
              target="_blank"
              rel="noreferrer"
              style={{
                textDecoration: "none",
                color: theme.colors.gray,
                margin: "0 0.25rem",
              }}
            >
              torarjim@gamail.com
            </a>
          </p>
          <ListTitle>Payment Methods</ListTitle>
          <div
            style={{
              display: "flex",
            }}
          >
            {paymentMethods.map((e, i) => (
              <div
                style={{
                  width: "60px",
                  height: "40px",
                }}
              >
                <img
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                  src={e}
                  alt="payment method"
                  key={i}
                />
              </div>
            ))}
          </div>
        </FooterColumn>
      </FooterContainer>
    </>
  );
};

export default withNamespaces()(Footer);
